import { useEffect, lazy, Suspense } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { CustomCursor } from "@/components/CustomCursor";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";

const Marquee = lazy(() => import("@/components/Marquee").then(m => ({ default: m.Marquee })));
const Skills = lazy(() => import("@/components/Skills").then(m => ({ default: m.Skills })));
const Projects = lazy(() => import("@/components/Projects").then(m => ({ default: m.Projects })));
const Contact = lazy(() => import("@/components/Contact").then(m => ({ default: m.Contact })));
const Footer = lazy(() => import("@/components/Footer").then(m => ({ default: m.Footer })));

function App() {
    useEffect(() => {
        if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;
        const lenis = new Lenis({ lerp: 0.09 });
        window.__lenis = lenis;
        let rafId;
        const raf = (time) => {
            lenis.raf(time);
            rafId = requestAnimationFrame(raf);
        };
        rafId = requestAnimationFrame(raf);
        return () => {
            cancelAnimationFrame(rafId);
            lenis.destroy();
            window.__lenis = null;
        };
    }, []);

    return (
        <div className="relative min-h-screen">
            <CustomCursor />
            <div className="grain-overlay" aria-hidden="true" />
            <Navbar />
            <main>
                <Hero />
                <Suspense fallback={null}>
                    <Marquee />
                    <Skills />
                    <Projects />
                    <Contact />
                </Suspense>
            </main>
            <Suspense fallback={null}>
                <Footer />
            </Suspense>
            <Toaster
                position="bottom-right"
                toastOptions={{
                    style: {
                        background: "#3D2314",
                        color: "#F5F0E6",
                        border: "1px solid rgba(245,240,230,0.15)",
                        fontFamily: '"JetBrains Mono", monospace',
                        fontSize: "13px",
                    },
                }}
            />
        </div>
    );
}

export default App;
